import Mapper from './Mapper'

/* istanbul ignore next */
export default class HeaderMapper extends Mapper {
  static toClient (data) {
    return data
  }
}
